import { render, staticRenderFns } from "./ModalDashboard.vue?vue&type=template&id=13361156&scoped=true&"
import script from "./ModalDashboard.vue?vue&type=script&lang=js&"
export * from "./ModalDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ModalDashboard.vue?vue&type=style&index=0&id=13361156&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13361156",
  null
  
)

export default component.exports